import GatewayContainer from '../config/GatewayContainer';
import GatewayNames from '../constant/GatewayNames';
import ListDataClient from '../client/list/ListDataClient';
import { MemoryDb } from 'minimongo';
import { InstanceContainer } from '../config/binding/InstanceBinding';
import Injectables from '../constant/Injectables';
import MessageUtil from '../util/MessageUtil';
import { query } from '@trlogic/client-js';
import Query = query.Query;
import { CaseEventReference } from '../domain/case/CaseDomains';
import { ListDataHistory } from '../domain/list/ListDomains';

class ListDataService {
  private listDataClient: ListDataClient = GatewayContainer.getInstance().get(GatewayNames.LIST_DATA_CLIENT);
  private localDb: MemoryDb = InstanceContainer.get(Injectables.LOCAL_DB);

  public addBulkData = (fileName: string, keyField: string, data: Record<string, any>[]) => {
    return this.listDataClient.addBulkData(fileName, keyField, data);
  };

  public createCollection = async (file: string, keyField: string, data: any[]) => {
    try {
      await this.listDataClient.createCollection(file, keyField, data);
      if (!this.localDb.getCollectionNames().includes(`list_${file}`)) {
        this.localDb.addCollection(`list_${file}`);
      }
    } catch (e) {}
  };

  public addData = async (fileName: string, keyField: string, data: Record<string, any>, message: boolean = true, caseReference?: CaseEventReference) => {
    data.id = String(data[keyField]);
    try {
      const result = await this.listDataClient.addData(fileName, data, caseReference);
      if (message) {
        if (result?.isUpdate) {
          MessageUtil.showUpdated('Data updated');
        } else {
          MessageUtil.showCreated('Data created');
        }
      }
    } catch (e) {
      MessageUtil.showError('Data not created');
    }
  };

  public getCount = (name: string, query: Query) => {
    return this.listDataClient.getCount(name, query);
  };

  public deleteListData = async (list: string, id: string, caseReference?: CaseEventReference) => {
    try {
      const response = await this.listDataClient.removeData(list, id, caseReference);
      if (response?.code) {
        return;
      }
      MessageUtil.showDeleted('Data removed');
    } catch (e) {
      MessageUtil.showError("Data couldn't removed");
    }
  };

  public removeAll = async (list: string, ids: string[]) => {
    try {
      const response = await this.listDataClient.bulkRemoveData(list, ids);
      if (response?.code) {
        return;
      }
      MessageUtil.showDeleted(`${ids.length} data(s) removed`);
    } catch (e) {
      MessageUtil.showDeleted(`${ids.length} data(s) couldn't removed`);
    }
  };

  public getHistory = (name: string, timestamp: number): Promise<ListDataHistory> => {
    return this.listDataClient.getHistory(name, timestamp);
  };
}

export default ListDataService;
